import { useTranslation } from "react-i18next";
import ItemRow, { SelectableItem } from "./item-row";
import { useState } from "react";
import ScSearchInput from "../../ui-kit/search-bar";
import {
  ActivityIndicator,
  FlatList,
  Pressable,
  Text,
  View,
} from "react-native";

type ItemSelectorListProps = Readonly<{
  items: SelectableItem[];
  selectedIds: string[];
  searchPlaceholderKey?: string;
  filterFn?: (item: SelectableItem, search: string) => boolean;
  onToggle: (item: SelectableItem) => void;
  onClear: () => void;
  onEndReached?: () => void;
  isFetchingMore?: boolean;
}>;

const ItemSelectorList = ({
  items,
  selectedIds,
  searchPlaceholderKey = "LABEL_SEARCH",
  filterFn,
  onToggle,
  onClear,
  onEndReached,
  isFetchingMore,
}: ItemSelectorListProps) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");

  const filtered = items.filter((item) => filterFn!(item, search));

  return (
    <>
      {/* Search */}
      <View className="px-5 pt-4 pb-2">
        <ScSearchInput
          value={search}
          placeholderKey={searchPlaceholderKey}
          containerClassName="rounded-full"
          onChangeText={setSearch}
        />
      </View>

      {/* Count */}
      <View className="flex-row justify-between items-center px-5 py-2">
        <Text className="text-sm text-slate">
          {selectedIds.length > 0
            ? t("LABEL_SELECTED_COUNT", { count: selectedIds.length })
            : t("LABEL_ITEMS_COUNT", { count: filtered.length })}
        </Text>
        <Pressable onPress={onClear} className="hover:bg-ash-3 hover:rounded-lg">
          <Text className="text-slate hover:underline">
            {t("BTN_CLEAR")}
          </Text>
        </Pressable>
      </View>

      {/* Item list */}
      <FlatList
        data={filtered}
        keyExtractor={(item) => item.itemId}
        renderItem={({ item }) => (
          <View className="px-5">
            <ItemRow
              item={item}
              selected={selectedIds.includes(item.itemId)}
              onToggle={() => onToggle(item)}
            />
          </View>
        )}
        showsVerticalScrollIndicator={false}
        ItemSeparatorComponent={() => (
          <View className="mx-5 border-b border-ash-3" />
        )}
        contentContainerStyle={{ paddingBottom: 8 }}
        onEndReached={onEndReached}
        onEndReachedThreshold={0.3}
        ListFooterComponent={
          isFetchingMore ? <ActivityIndicator className="py-4" /> : null
        }
      />
    </>
  );
};

export default ItemSelectorList;
